export function VersionBadge() {
	return (
		<div
			className="fixed bottom-2 right-3 z-10 select-none pointer-events-none text-caption font-mono"
			title={`commit ${__APP_COMMIT__}`}
		>
			v{__APP_VERSION__}
		</div>
	);
}
